<template>
  <el-dialog
    :visible="visible"
    @update:visible="$emit('update:visible', $event)"
    width="980px"
    top="4vh"
    append-to-body
    :close-on-click-modal="false"
    custom-class="customer-details-modal-shell"
    @closed="onDialogClosed"
  >
    <div slot="title" class="cdm-title">
      <i class="el-icon-user-solid cdm-title__icon" aria-hidden="true" />
      <span>客户详情</span>
    </div>

    <div class="cdm-body">
      <el-scrollbar class="cdm-scroll">
        <div class="cdm-inner">
          <!-- 左栏 -->
          <aside class="cdm-col cdm-col--left">
            <div class="cdm-card cdm-profile">
              <div class="cdm-profile__avatar-wrap">
                <head-image
                  class="cdm-profile__avatar"
                  :name="form.nickName"
                  :url="form.headImage"
                  :size="72"
                  radius="12px"
                  :online="form.online"
                  :online-status="form.onlineStatus"
                  :is-show-user-info="false"
                />
              </div>
              <div class="cdm-profile__name">{{ form.nickName || "—" }}</div>
              <div class="cdm-profile__badge-row">
                <span class="cdm-status-pill" :class="'cdm-status-pill--' + statusKey">
                  <span class="cdm-status-dot" />
                  {{ statusLabel }}
                </span>
                <span class="cdm-profile__id">ID: {{ form.id || "—" }}</span>
              </div>
              <ul class="cdm-meta-list">
                <li class="cdm-meta-row">
                  <i class="el-icon-location-outline cdm-meta-icon" />
                  <span class="cdm-meta-label">地理位置</span>
                  <span class="cdm-meta-value">{{ form.lastLoginAddress || "—" }}</span>
                </li>
                <li class="cdm-meta-row">
                  <i class="el-icon-connection cdm-meta-icon" />
                  <span class="cdm-meta-label">IP 地址</span>
                  <span class="cdm-meta-value">{{ form.lastLoginIp || form.ip || "—" }}</span>
                </li>
                <li class="cdm-meta-row">
                  <i class="el-icon-mobile-phone cdm-meta-icon" />
                  <span class="cdm-meta-label">客户来源</span>
                  <span class="cdm-meta-value">{{ form.visitorSource || "—" }}</span>
                </li>
              </ul>
            </div>

            <div class="cdm-card cdm-fields">
              <div class="cdm-field-row">
                <label class="cdm-field-label">名称备注</label>
                <div class="cdm-field-control">
                  <div class="cdm-field-surface">
                    <div class="cdm-contact-display cdm-name-remark-display">
                      <span class="cdm-contact-text" :class="{ 'cdm-name-remark--muted': nameRemarkEditable && !form.remarkNickName }">{{
                        form.showNickName || "未设置备注名"
                      }}</span>
                    </div>
                    <button type="button" class="cdm-field-icon-btn" title="编辑备注" @click="onEditNameRemark">
                      <i class="el-icon-edit" />
                    </button>
                  </div>
                </div>
              </div>
              <div class="cdm-field-row">
                <div class="cdm-field-label-row">
                  <label class="cdm-field-label">联系方式备注</label>
                  <el-dropdown class="cdm-contact-kind-dropdown" trigger="click" placement="bottom-end" @command="onContactKindChange">
                    <span class="cdm-contact-kind-trigger" role="button" tabindex="0" aria-label="选择联系方式类型">
                      <i class="el-icon-arrow-down cdm-field-label-arrow" />
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="wechat"><i class="el-icon-chat-dot-round" /> 微信</el-dropdown-item>
                      <el-dropdown-item command="qq"><i class="el-icon-message-solid" /> QQ</el-dropdown-item>
                      <el-dropdown-item command="email"><i class="el-icon-message" /> 邮箱</el-dropdown-item>
                      <el-dropdown-item command="phone"><i class="el-icon-phone-outline" /> 电话</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
                <div class="cdm-field-control cdm-field-control--contact">
                  <div class="cdm-field-surface">
                    <div class="cdm-contact-display">
                      <i :class="contactKindIcon" />
                      <span class="cdm-contact-text">{{ form.contactAccount || "—" }}</span>
                    </div>
                    <button type="button" class="cdm-field-icon-btn" title="编辑">
                      <i class="el-icon-edit" />
                    </button>
                  </div>
                  <button type="button" class="cdm-field-add-btn" title="添加">
                    <i class="el-icon-plus" />
                  </button>
                </div>
              </div>
            </div>
          </aside>

          <!-- 右栏 -->
          <div class="cdm-col cdm-col--right">
            <!-- 跟进管理 + 标签与限制：同一 card 内两列，意向等级为分段控件 -->
            <div class="cdm-card cdm-manage-panel">
              <div class="cdm-manage-grid">
                <div class="cdm-mp-col cdm-mp-follow">
                  <div class="cdm-mp-section-title">跟进管理</div>
                  <div class="cdm-form-item">
                    <label class="cdm-card-sub">长期跟进备注</label>
                    <el-input v-model="form.followRemark" type="textarea" :rows="4" resize="none" placeholder="输入客户长期需求或特殊注意事项..." />
                  </div>
                  <div class="cdm-form-item">
                    <label class="cdm-card-sub">客户意向等级</label>
                    <div class="cdm-intent-seg" role="group" aria-label="客户意向等级">
                      <button
                        v-for="lv in intentLevels"
                        :key="lv.value"
                        type="button"
                        class="cdm-intent-seg__btn"
                        :class="{ 'is-active': form.intentLevel === lv.value }"
                        @click="form.intentLevel = lv.value"
                      >
                        {{ lv.label }}
                      </button>
                    </div>
                  </div>
                </div>

                <div class="cdm-mp-col cdm-mp-tags">
                  <div class="cdm-mp-section-title">标签与限制</div>
                  <div class="cdm-form-item">
                    <label class="cdm-card-sub">分类标签</label>
                    <div class="cdm-tags-box">
                      <div class="cdm-tags-row">
                        <el-tag v-for="(tag, ti) in tagList" :key="ti" closable size="small" class="cdm-tag" @close="removeTag(ti)">
                          {{ tag }}
                        </el-tag>
                        <el-input
                          v-if="tagInputVisible"
                          ref="tagInputRef"
                          v-model="tagInputValue"
                          size="mini"
                          class="cdm-tag-input"
                          @keyup.enter.native="confirmTag"
                          @blur="confirmTag"
                        />
                        <el-button v-else size="mini" class="cdm-tag-add" @click="showTagInput">+ 添加</el-button>
                      </div>
                    </div>
                  </div>
                  <div class="cdm-danger-actions">
                    <el-button
                      size="small"
                      plain
                      class="cdm-btn-danger"
                      :loading="blacklistLoading"
                      @click="removeFromBlacklist"
                      v-if="form && form.isIpBlacklist"
                    >
                      <i class="el-icon-refresh-left" /> 解除屏蔽 IP
                    </el-button>
                    <el-button size="small" plain class="cdm-btn-danger" :loading="blacklistLoading" @click="addToBlacklist" v-else>
                      <i class="el-icon-circle-close" /> 屏蔽 IP
                    </el-button>
                    <!-- <el-button size="small" plain class="cdm-btn-danger" @click="$emit('block-ip')"> <i
                        class="el-icon-lock" /> 屏蔽 IP </el-button> -->
                  </div>
                  <div class="cdm-mp-tags-footer">
                    <el-button type="primary" plain size="small" class="cdm-manage-save" @click="emitSectionSave('tags')"> 保存 </el-button>
                  </div>
                </div>
              </div>
            </div>

            <div class="cdm-right-bottom">
              <div class="cdm-card cdm-history">
                <div class="cdm-bottom-panel-head">
                  <div class="cdm-card-head">访问历史</div>
                  <div class="cdm-history-meta">共 {{ visitRows.length }} 次</div>
                </div>
                <div class="cdm-history-table-wrap">
                  <el-table :data="visitRows" size="small" stripe class="cdm-table">
                    <el-table-column prop="seq" label="次序" min-width="80" />
                    <el-table-column prop="date" label="日期" min-width="96" />
                    <el-table-column prop="agent" label="对接客服" min-width="96">
                      <template slot-scope="scope">
                        <el-link type="primary">{{ scope.row.agent }}</el-link>
                        <!-- <el-button type="text" size="small">{{ scope.row.agent }}</el-button> -->
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>

              <div class="cdm-card cdm-records">
                <div class="cdm-bottom-panel-head cdm-bottom-panel-head--row">
                  <span class="cdm-bottom-panel-head__title">跟进记录</span>
                  <el-button type="text" size="mini" class="cdm-link-add" @click="$emit('add-follow')">+ 新增</el-button>
                </div>
                <ul class="cdm-timeline">
                  <li v-for="(rec, ri) in followRecords" :key="ri" class="cdm-tl-item" :class="'cdm-tl-item--' + rec.tone">
                    <div class="cdm-tl-dot" />
                    <div class="cdm-tl-body">
                      <div class="cdm-tl-headrow">
                        <div class="cdm-tl-title">{{ rec.title }}</div>
                        <div class="cdm-tl-time">{{ rec.time }}</div>
                      </div>
                      <div class="cdm-tl-desc">{{ rec.desc }}</div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </el-scrollbar>
    </div>

    <span slot="footer" class="cdm-footer">
      <el-button @click="close">取消</el-button>
      <el-button type="primary" class="cdm-footer-save" @click="emitSave">保存更改</el-button>
    </span>
  </el-dialog>
</template>

<script>
import HeadImage from "../common/HeadImage.vue";

const STATUS_REV = {
  1: "online",
  2: "away",
  3: "busy",
  4: "offline"
};

export default {
  name: "CustomerDetailsModal",
  components: {
    HeadImage
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    detail: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      initialRemarkNickName: "",
      blacklistLoading: false,
      form: {},
      tagList: [],
      tagInputVisible: false,
      tagInputValue: "",
      intentLevels: [
        { value: "high", label: "高" },
        { value: "mid", label: "中" },
        { value: "low", label: "低" }
      ],
      contactKindIcons: {
        wechat: "el-icon-chat-dot-round",
        qq: "el-icon-message-solid",
        email: "el-icon-message",
        phone: "el-icon-phone-outline"
      },
      visitRows: [
        { seq: "第二次来访", date: "2024-05-24", agent: "林晓雅" },
        { seq: "首次来访", date: "2024-05-20", agent: "—" }
      ],
      followRecords: [
        {
          tone: "primary",
          title: "回访标记: 电话确认",
          time: "今日 10:24",
          desc: "与客户初步确认采购意向。"
        },
        {
          tone: "success",
          title: "状态变更: 活跃中",
          time: "昨日 14:15",
          desc: "活跃度上升。"
        },
        {
          tone: "muted",
          title: "首次建档",
          time: "2024-05-20",
          desc: "创建客户档案。"
        }
      ]
    };
  },
  computed: {
    statusKey() {
      const n = this.form.onlineStatus != null ? Number(this.form.onlineStatus) : null;
      if (n >= 1 && n <= 4) return STATUS_REV[n];
      return this.form.online ? "online" : "offline";
    },
    statusLabel() {
      const map = {
        online: "在线",
        away: "挂起",
        busy: "忙碌",
        offline: "离线"
      };
      return map[this.statusKey] || "离线";
    },
    contactKindIcon() {
      const k = this.form.contactKind || "wechat";
      return this.contactKindIcons[k] || this.contactKindIcons.wechat;
    },
    /** 与 Friend.vue 一致：仅好友可改备注（接口 /friend/update/remark） */
    nameRemarkEditable() {
      const id = this.form && this.form.id;
      return id != null && this.friendStore.isFriend(id);
    }
  },
  watch: {
    detail: {
      immediate: true,
      deep: true,
      handler(detail) {
        if (!detail) return;
        const d = { ...detail };
        const uid = d.id;
        const friend = uid != null ? this.friendStore.findFriend(uid) : null;

        const remarkNickName = friend ? friend.remarkNickName || "" : d.remarkNickName || d.nameRemark || "";

        const nickName = d.nickName || "访客";

        const showNickName = friend ? friend.showNickName || nickName : remarkNickName?.trim() ? remarkNickName : nickName;

        this.initialRemarkNickName = remarkNickName;

        this.form = {
          nickName,
          headImage: d.headImage || d.headImageThumb || "",
          online: d.online !== false,
          onlineStatus: d.onlineStatus != null ? Number(d.onlineStatus) : d.online ? 1 : 4,
          lastLoginIp: d.lastLoginIp,
          lastLoginAddress: d.lastLoginAddress,
          remarkNickName,
          showNickName,
          contactAccount: d.contactAccount || "zxm_tech_2024",
          contactKind: d.contactKind || "wechat",
          followRemark: d.followRemark || "",
          intentLevel: d.intentLevel || "high",
          ...d
        };

        this.tagList = Array.isArray(d.tags) && d.tags.length ? [...d.tags] : ["高净值", "意向客户"];
      }
    }
  },
  methods: {
    close() {
      this.$emit("update:visible", false);
    },
    onDialogClosed() {
      this.$emit("closed");
    },
    onContactKindChange(cmd) {
      this.form.contactKind = cmd;
    },
    /**
     * 与 Friend.vue onEditRemark 相同：PUT /friend/update/remark
     */
    onEditNameRemark() {
      if (!this.nameRemarkEditable) {
        this.$message.warning("仅好友可修改备注名");
        return;
      }
      const f = this.friendStore.findFriend(this.form.id);
      const inputValue = f ? f.showNickName || "" : this.form.nickName || "";
      this.$prompt("请输入好友备注", "修改备注", {
        inputValue,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputValidator: (value) => {
          if (value && value.length > 32) {
            return "好友备注长度不能大于32";
          }
        }
      })
        .then((o) => {
          const data = {
            friendId: this.form.id,
            remarkNickName: o.value
          };
          this.$http({
            url: "/friend/update/remark",
            method: "put",
            data
          }).then((friend) => {
            this.friendStore.updateFriend(friend);
            this.chatStore.updateChatFromFriend(friend);
            this.form.remarkNickName = friend.remarkNickName || "";
            this.form.showNickName = friend.showNickName || this.form.nickName || "";
            this.initialRemarkNickName = this.form.remarkNickName;
            this.$message.success("备注已更新");
          });
        })
        .catch(() => {});
    },
    submitRemarkIfChanged() {
      return new Promise((resolve, reject) => {
        const cur = (this.form.remarkNickName || "").trim();
        const prev = (this.initialRemarkNickName || "").trim();
        if (!this.nameRemarkEditable || cur === prev) {
          resolve();
          return;
        }
        this.$http({
          url: "/friend/update/remark",
          method: "put",
          data: { friendId: this.form.id, remarkNickName: this.form.remarkNickName || "" }
        })
          .then((friend) => {
            this.friendStore.updateFriend(friend);
            this.chatStore.updateChatFromFriend(friend);
            this.form.remarkNickName = friend.remarkNickName || "";
            this.form.showNickName = friend.showNickName || this.form.nickName || "";
            this.initialRemarkNickName = this.form.remarkNickName;
            resolve();
          })
          .catch(reject);
      });
    },
    showTagInput() {
      this.tagInputVisible = true;
      this.$nextTick(() => {
        const ref = this.$refs.tagInputRef;
        if (ref && ref.focus) ref.focus();
      });
    },
    confirmTag() {
      const v = (this.tagInputValue || "").trim();
      if (v) {
        this.tagList.push(v);
      }
      this.tagInputValue = "";
      this.tagInputVisible = false;
    },
    removeTag(i) {
      this.tagList.splice(i, 1);
    },
    emitSectionSave(which) {
      this.$emit("save-section", { which, form: { ...this.form }, tags: [...this.tagList] });
      this.$message.success("已保存");
    },
    emitSave() {
      this.submitRemarkIfChanged()
        .then(() => {
          const payload = { form: { ...this.form }, tags: [...this.tagList] };
          this.$emit("save", payload);
          this.close();
        })
        .catch(() => {});
    },
    addToBlacklist() {
      if (!this.form || !this.form.id) {
        this.$message.warning("无法拉黑：缺少客户 ID");
        return;
      }
      this.blacklistLoading = true;
      const id = this.form.id;
      this.$http({
        url: "/user/addBlacklist?userId=" + id,
        method: "POST",
        data: { userId: id }
      })
        .then(() => {
          this.form.isIpBlacklist = true;
          this.$emit("blacklist-updated", { userId: id, isIpBlacklist: true });
          this.$message.success("操作成功");
        })
        .finally(() => {
          this.blacklistLoading = false;
        });
    },
    removeFromBlacklist() {
      if (!this.form || !this.form.id) {
        this.$message.warning("无法解除屏蔽：缺少客户 ID");
        return;
      }
      this.blacklistLoading = true;
      const id = this.form.id;
      this.$http({
        url: "/user/delBlacklist?userId=" + id,
        method: "POST",
        data: { userId: id }
      })
        .then(() => {
          this.form.isIpBlacklist = false;
          this.$emit("blacklist-updated", { userId: id, isIpBlacklist: false });
          this.$message.success("操作成功");
        })
        .finally(() => {
          this.blacklistLoading = false;
        });
    }
  }
};
</script>

<style scoped lang="scss">
.cdm-title {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 600;
  color: #303133;

  &__icon {
    font-size: 18px;
    color: #409eff;
  }
}

.cdm-body {
  // max-height: min(760px, calc(92vh - 180px));
}

.cdm-scroll {
  height: 100%;

  ::v-deep .el-scrollbar__wrap {
    overflow-x: hidden;
  }
}

.cdm-inner {
  display: flex;
  gap: 20px;
  align-items: flex-start;
  padding: 4px 2px 8px;
  box-sizing: border-box;
}

.cdm-col--left {
  width: 300px;
  flex-shrink: 0;
}

.cdm-col--right {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.cdm-card {
  padding: 24px;
  border-radius: 4px;
  border: 1px solid #c3c6d7;
  background: #fff;
  box-sizing: border-box;
}

.cdm-profile {
  text-align: center;
}

.cdm-profile__avatar-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 12px;
  border-radius: 12px;
  width: 80px;
  height: 80px;
  margin: 0 auto;
  border: 4px solid rgba(0, 82, 217, 0.2);
  background: lightgray 0px 0px / 100% 100% no-repeat;
}

.cdm-profile__name {
  font-size: 24px;
  font-weight: 400;
  color: #191b23;

  margin-bottom: 10px;
}

.cdm-profile__badge-row {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 16px;
}

.cdm-status-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 2px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 500;

  &--online {
    background: #ecfdf3;
    color: #15803d;
  }

  &--away {
    background: #fffbeb;
    color: #b45309;
  }

  &--busy {
    background: #fef2f2;
    color: #991b1b;
  }

  &--offline {
    background: #f3f4f6;
    color: #6b7280;
  }
}

.cdm-status-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
}

.cdm-profile__id {
  font-size: 12px;
  color: #6b7280;
}

.cdm-meta-list {
  list-style: none;
  margin: 0;
  padding: 0;
  text-align: left;
  border-top: 1px solid #c3c6d7;
}

.cdm-meta-row {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 10px 0;
  // border-bottom: 1px solid #eef0f4;
  font-size: 13px;
  font-weight: 400;

  // &:last-child {
  //   border-bottom: none;
  // }
}

.cdm-meta-icon {
  color: #9ca3af;
  margin-top: 4px;
  flex-shrink: 0;
}

.cdm-meta-label {
  color: #737686;
  width: 72px;
  flex-shrink: 0;
}

.cdm-meta-value {
  color: #191b23;
  flex: 1;
  word-break: break-all;
  text-align: right;
}

.cdm-fields {
  margin-top: 14px;
  text-align: left;
}

.cdm-field-row + .cdm-field-row {
  margin-top: 14px;
}

.cdm-field-label {
  display: block;
  font-size: 12px;
  color: #737686;
  margin-bottom: 8px;
}

/* 联系方式备注：标题与下拉箭头同一行两端对齐 */
.cdm-field-label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;

  .cdm-field-label {
    margin-bottom: 0;
  }
}

.cdm-contact-kind-dropdown {
  flex-shrink: 0;
  line-height: 1;
}

.cdm-contact-kind-trigger {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  outline: none;

  &:focus-visible .cdm-field-label-arrow {
    color: #409eff;
  }
}

.cdm-field-label-arrow {
  flex-shrink: 0;
  font-size: 14px;
  color: #909399;
}

.cdm-field-control {
  width: 100%;
}

/* 联系方式：浅紫框与「+」分列，加号在框外右侧 */
.cdm-field-control--contact {
  display: flex;
  align-items: center;
  gap: 8px;

  .cdm-field-surface {
    flex: 1;
    min-width: 0;
  }
}

.cdm-field-add-btn {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  padding: 0;
  margin: 0;
  border: none;
  border-radius: 8px;
  background: transparent;
  cursor: pointer;
  color: #303133;
  font-size: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  &:hover {
    color: #409eff;
    background: rgba(64, 158, 255, 0.08);
  }
}

/* 名称备注 / 联系方式备注：同一浅紫底容器，下拉 + 编辑 + 加号在同一框内 */
.cdm-field-surface {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 6px 12px;
  min-height: 38px;
  box-sizing: border-box;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0);
  background: #faf8ff;
}

.cdm-field-el-input {
  flex: 1;
  min-width: 0;

  ::v-deep .el-input__inner {
    border: none !important;
    background: transparent !important;
    box-shadow: none !important;
    height: 30px;
    line-height: 30px;
    padding-left: 0;
    padding-right: 8px;
    color: #303133;
  }
}

.cdm-field-icon-btn {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  padding: 0;
  margin: 0;
  border: none;
  border-radius: 6px;
  background: transparent;
  cursor: pointer;
  color: #909399;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  &:hover {
    color: #409eff;
    background: rgba(255, 255, 255, 0.55);
  }
}

.cdm-contact-display {
  flex: 1;
  min-width: 0;
  width: 100%;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0;
  font-size: 13px;
  color: #303133;
  box-sizing: border-box;
}

.cdm-contact-text {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cdm-name-remark--muted {
  color: #909399;
  font-style: italic;
}

/* 跟进 + 标签：单一 card */
.cdm-manage-panel {
  padding-bottom: 12px;
}

.cdm-manage-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0;
  align-items: start;
}

.cdm-mp-follow {
  padding-right: 16px;
}

.cdm-mp-tags {
  padding-left: 24px;
}

.cdm-mp-section-title {
  font-size: 20px;
  font-weight: 400;
  color: #191b23;
  margin-bottom: 16px;
}

/* 高 / 中 / 低：独立按钮，间距 4px */
.cdm-intent-seg {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  width: 100%;
  max-width: 280px;
}

.cdm-intent-seg__btn {
  flex: 1;
  min-width: 0;
  margin: 0;
  padding: 8px 12px;
  box-sizing: border-box;
  border-radius: 2px;
  border: 1px solid #c3c6d7;
  background: #fff;
  cursor: pointer;
  font-size: 13px;
  color: #606266;
  line-height: 1.2;
  transition: background 0.15s, color 0.15s, border-color 0.15s;

  &:hover:not(.is-active) {
    background: #f9fafb;
  }

  &.is-active {
    border: 2px solid #003da6;
    background: rgba(0, 61, 166, 0.05);
    color: #003da6;
    font-weight: 600;
  }
}

.cdm-tags-box {
  padding: 8px;
  // background: #f5f9ff;
  // border: 1px solid #e8eef8;
  // border-radius: 8px;

  border-radius: 2px;
  border: 1px solid #c3c6d7;
  background: #faf8ff;
}

.cdm-mp-tags-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
  padding-top: 12px;
}

.cdm-manage-save {
  border-radius: 999px !important;
  padding: 8px 32px !important;
  border-radius: 4px !important;
  background: #0052d9 !important;
  color: white !important;
}

.cdm-card-head {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 12px;

  &--between {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}

.cdm-card-sub {
  display: block;
  font-size: 12px;
  color: #737686;
  margin-bottom: 8px;
}

.cdm-form-item + .cdm-form-item {
  margin-top: 14px;
}

.cdm-tags-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}

.cdm-tag {
  // padding: 4.5px 8px 5.5px 8px !important;
  // box-sizing: border-box;
  // border-radius: 4px !important;
  // background: #0052D9;
  // height: 26px !important;
  // line-height: 26px !important;
  font-size: 10px;
  height: 16px;
  line-height: 16px;
  text-align: center;
  border-radius: 5px;
  border: 0;
  // margin-left: 3px;
  padding: 0 6px !important;
  color: white !important;
}

::v-deep .el-tag {
  height: 26px !important;
  line-height: 26px !important;
  border-radius: 4px !important;
  background: #0052d9 !important;

  .el-tag__close {
    color: white !important;
  }
}

.cdm-tag-input {
  width: 120px;
}

.cdm-tag-add {
  border-style: dashed;
}

.cdm-danger-actions {
  display: flex;
  gap: 10px;
  margin-top: 16px;
}

.cdm-btn-danger {
  border-color: #ba1a1a !important;
  color: #ba1a1a !important;

  &:hover {
    background: #fef2f2 !important;
  }
}

/* 访问历史 | 跟进记录：单列总高 340px；头部与内容区 flex 分配剩余高度 */
$cdm-bottom-panel-h: 340px;

.cdm-right-bottom {
  display: flex;
  gap: 16px;
  align-items: stretch;
}

.cdm-history,
.cdm-records {
  flex: 1;
  min-width: 0;
  height: $cdm-bottom-panel-h;
  max-height: $cdm-bottom-panel-h;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-sizing: border-box;
  padding: 0 !important;
}

.cdm-bottom-panel-head {
  flex-shrink: 0;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 2px;
  padding: 16px;
  border-bottom: 1px solid #c3c6d7;

  .cdm-card-head {
    margin-bottom: 0;
    line-height: 1.25;
  }

  &--row {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
  }
}

.cdm-bottom-panel-head__title {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
}

.cdm-history-meta {
  font-size: 12px;
  color: #909399;
  margin: 0;
  line-height: 1.3;
}

.cdm-table {
  width: 100%;
}

.cdm-history-table-wrap {
  flex: 1;
  min-height: 0;
  /* flex 子项默认 min-width:auto，会撑开父级导致表格被横向裁切 */
  min-width: 0;
  width: 100%;
  overflow-x: auto;
  overflow-y: auto;
  box-sizing: border-box;
  -webkit-overflow-scrolling: touch;

  ::v-deep .el-table {
    width: 100%;

    thead {
      color: #737686;
      font-size: 12px;

      th {
        padding: 0 !important;
        height: 32px;
        background-color: #f3f3fe !important;
        color: #737686;

        > .cell {
          padding: 0 16px;
          line-height: 32px;
          font-size: 12px;
          color: #737686;
        }
      }
    }

    tbody td {
      padding: 0 !important;
      height: 44px;

      > .cell {
        padding: 12px 16px;
        box-sizing: border-box;
      }
    }
  }
}

.cdm-link-add {
  padding: 0;
}

.cdm-timeline {
  list-style: none;
  margin: 0;
  flex: 1;
  min-height: 0;
  padding: 16px;
  overflow-x: hidden;
  overflow-y: auto;
  box-sizing: border-box;
}

.cdm-tl-item {
  position: relative;
  padding-left: 18px;
  padding-bottom: 16px;

  &:last-child {
    padding-bottom: 0;
  }

  &::before {
    content: "";
    position: absolute;
    left: 5px;
    top: 10px;
    bottom: -6px;
    width: 2px;
    background: #e5e7eb;
  }

  &:last-child::before {
    display: none;
  }
}

.cdm-tl-dot {
  position: absolute;
  left: 0;
  top: 4px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: 2px solid #fff;
  box-sizing: border-box;
}

.cdm-tl-item--primary .cdm-tl-dot {
  background: #2563eb;
}

.cdm-tl-item--success .cdm-tl-dot {
  background: #16a34a;
}

.cdm-tl-item--muted .cdm-tl-dot {
  background: #9ca3af;
}

.cdm-tl-body {
  min-width: 0;
}

.cdm-tl-headrow {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 4px;
}

.cdm-tl-title {
  flex: 1;
  min-width: 0;
  font-size: 13px;
  font-weight: 600;
  color: #111827;
}

.cdm-tl-time {
  flex-shrink: 0;
  margin: 0;
  font-size: 12px;
  color: #9ca3af;
  white-space: nowrap;
  text-align: right;
}

.cdm-tl-desc {
  font-size: 12px;
  color: #6b7280;
  line-height: 1.45;
}

.cdm-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.cdm-footer-save {
  background: #0052d9 !important;
  border-color: #0052d9 !important;
}
</style>

<style lang="scss">
.customer-details-modal-shell.el-dialog {
  border-radius: 14px;
}

.customer-details-modal-shell .el-dialog__header {
  padding: 16px 20px 8px;
  text-align: left;
  border-bottom: 1px solid #c3c6d7;
}

.customer-details-modal-shell .el-dialog__body {
  padding: 0 20px;
}

.customer-details-modal-shell .el-dialog__footer {
  padding: 12px 20px 18px;
  border-top: 1px solid #c3c6d7;
  background: #faf8ff;
}
</style>
